@if (isInitialized && component) {
  <oe-chart [title]="component.alias + '&nbsp;-&nbsp;' + ('EDGE.HISTORY.PHASE_ACCURATE' | translate)"
    [period]="service.historyPeriod.value">
    @switch (componentType) {
      @case ('sum') {
        <sumChart [isOnlyChart]="true"></sumChart>
      }
      @case ('consumptionMeter') {
        <consumptionMeterChart [isOnlyChart]="true"></consumptionMeterChart>
      }
      @case ('evcs') {
        <evcsChart [isOnlyChart]="true"></evcsChart>
      }
      @case ('heat') {
        <heatChart [isOnlyChart]="true"></heatChart>
      }
    }
  </oe-chart>
}
@if (isInitialized) {
  <oe-footer-subnavigation [backButton]="true"
  [navigationOptions]="navigationButtons"></oe-footer-subnavigation>
}
